import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { COMPANY } from "./Privacy";

function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="font-heading text-xl text-graphite">{title}</h2>
      <div className="mt-3 text-sm text-slate-600 leading-relaxed space-y-3">{children}</div>
    </section>
  );
}

export default function Terms() {
  const { lang } = useLang();
  return (
    <div data-testid="terms-page">
      <section className="bg-[#071A2D] text-white pt-16 pb-12">
        <div className="max-w-4xl mx-auto px-5 lg:px-8">
          <div className="text-xs uppercase tracking-[0.2em] text-[#00D4FF] mb-3">Legal</div>
          <h1 className="font-heading text-4xl sm:text-5xl">Terms of Use</h1>
          <p className="mt-4 text-white/70 text-sm">Last updated: June 2026</p>
        </div>
      </section>
      <section className="bg-white py-12">
        <div className="max-w-4xl mx-auto px-5 lg:px-8">
          {lang === "te" && (
            <div className="mb-6 rounded-xl bg-mist border border-slate-200 px-4 py-3 text-sm text-slate-700" data-testid="terms-te-note">
              ఈ నియమాలు ఆంగ్లంలో అందించబడ్డాయి. ఏవైనా సందేహాలుంటే {COMPANY.email} కు వ్రాయండి — మేము తెలుగులో సహాయం చేస్తాము.
            </div>
          )}
          <p className="text-sm text-slate-600 leading-relaxed">
            This website is operated by <strong>{COMPANY.legalName}</strong> (CIN: {COMPANY.cin}), registered office at {COMPANY.address}. By using this website you agree to these Terms of Use.
          </p>

          <Section title="1. Informational content only">
            <p>All content on this website — including product descriptions, the Savings Estimator, the "Savings Journey" illustrations and the guided questionnaire — is for general information. It does not constitute an offer, professional engineering advice, or a contractual commitment. Any engagement with WattZap is governed solely by a separately signed written agreement.</p>
          </Section>

          <Section title="2. Estimates and savings figures">
            <p>All savings figures, charts and estimates shown on this website are <strong>indicative only</strong>. Actual savings depend on your electricity tariff, load profile, site conditions, DISCOM approvals and operating behaviour, and are confirmed only after a professional site assessment and measured data. WattZap does not guarantee any specific savings amount or percentage through this website. Illustrations based on site analyses are anonymised, rounded and provided in good faith to the best of our knowledge.</p>
          </Section>

          <Section title="3. AI assistant">
            <p>The chat assistant on this website uses artificial intelligence. Its responses are automatically generated, informational only, may occasionally be inaccurate, and are not professional, legal, financial or electrical-safety advice. Never rely on the assistant for electrical work — always engage licensed professionals.</p>
          </Section>

          <Section title="4. SolarLease and financed offerings">
            <p>SolarLease and other financed offerings are site-specific and subject to technical feasibility, credit assessment and definitive agreements. Descriptions on this website do not constitute an offer of financing.</p>
          </Section>

          <Section title="5. Third-party links">
            <p>Links to external services (including the WattZap EnergyScan portal) are provided for convenience. Those services have their own terms and privacy notices.</p>
          </Section>

          <Section title="6. Intellectual property">
            <p>The WattZap name, logo, and all website content are the property of {COMPANY.legalName}. You may not reproduce them without written permission, except for personal, non-commercial reference.</p>
          </Section>

          <Section title="7. Limitation of liability">
            <p>To the maximum extent permitted by law, {COMPANY.legalName} is not liable for any loss arising from reliance on the information, estimates or AI-generated responses on this website.</p>
          </Section>

          <Section title="8. Governing law">
            <p>These terms are governed by the laws of India. Courts at Hyderabad, Telangana shall have exclusive jurisdiction.</p>
          </Section>

          <Section title="9. Contact">
            <p>Questions about these terms: <a href={`mailto:${COMPANY.email}`} className="text-[#0092b0] underline">{COMPANY.email}</a></p>
          </Section>

          <div className="mt-10 text-sm">
            <Link to="/privacy" className="text-[#0092b0] underline" data-testid="terms-to-privacy">Read our Privacy Policy →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
